import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { i18n } from "@/lib/i18n";
import { appShellTitle } from "@/lib/seo/head";

function ShareShell() {
  const { t } = useTranslation();
  return (
    <section>
      <h1 className="text-2xl font-semibold tracking-tight">{t("shells.share")}</h1>
    </section>
  );
}

export const Route = createFileRoute("/share/$token")({
  head: () => ({ meta: [{ title: appShellTitle(i18n.t("shells.share")) }] }),
  component: ShareShell,
});
